import utils from "Sources/utils/utils";
import request from "Sources/services/request";

let MaterialService = {};

((MaterialService) =>
{
  MaterialService.getAllMaterials = function()
  {
    return request.get({
      url:  utils.getServiceUrl("/materials"),
      cache: false,
      dataType: request.DATA_TYPES.JSON,
      contentType: request.CONTENT_TYPES.APPLICATION_JSON
    })
      .then((data) =>
      {
        let rtrnData = null;

        if(utils.isNotNull(data) && data.result === "success" && data.data)
        {
          rtrnData = data.data;
        }

        return rtrnData;
      });
  };

  MaterialService.getAllMaterialCategories = function()
  {
    return request.get({
      url:  utils.getServiceUrl("/material_categories"),
      cache: false,
      dataType: request.DATA_TYPES.JSON,
      contentType: request.CONTENT_TYPES.APPLICATION_JSON
    })
      .then((data) =>
      {
        let rtrnData = null;

        if(utils.isNotNull(data) && data.result === "success" && data.data)
        {
          rtrnData = data.data;
        }

        return rtrnData;
      });
  };

})(MaterialService);

module.exports = MaterialService;



// WEBPACK FOOTER //
// ./app/js/services/material-service.js